var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5V9.75C11 10.4392 10.4392 11 9.75 11H2.25C1.56075 11 1 10.4392 1 9.75V8.5H0V9.75C0 10.9905 1.0095 12 2.25 12H9.75C10.9905 12 12 10.9905 12 9.75V8.5H11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1035 5.3535L9.3965 4.6465L6.5 7.54275V0H5.5V7.54275L2.6035 4.6465L1.8965 5.3535L6 9.45725L10.1035 5.3535Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a24f4b618bbd075fdc18c9f7d8548929.svg";
export { ForwardRef as ReactComponent };